import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs/modular/sortable.core.esm.js'

export default class extends Controller {
  static values = { url: String }
  static targets = ["body"]

  connect() {
    if (!this.hasBodyTarget) {
      console.error('swimlane-sortable: body target not found')
      return
    }

    this.sortable = new Sortable(this.bodyTarget, {
      animation: 150,
      draggable: 'tr[data-swimlane-id]',
      handle: '.drag-handle',
      ghostClass: 'opacity-50',
      chosenClass: 'bg-primary-50',
      onEnd: (evt) => {
        if (evt.oldIndex !== evt.newIndex) {
          this.saveOrder()
        }
      }
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  async saveOrder() {
    const rows = this.bodyTarget.querySelectorAll('tr[data-swimlane-id]')
    const ids = Array.from(rows)
      .map(row => `swimlane_ids[]=${row.dataset.swimlaneId}`)
      .join('&')

    if (!ids) {
      console.error('swimlane-sortable: no swimlane ids found')
      return
    }

    try {
      const response = await fetch(this.urlValue, {
        method: 'PUT',
        body: ids,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`)
      }

      this.updatePositionDisplay()
    } catch (error) {
      console.error('Failed to save swimlane order:', error)
    }
  }

  updatePositionDisplay() {
    this.bodyTarget.querySelectorAll('tr[data-swimlane-id]').forEach((row, index) => {
      const positionCell = row.querySelector('[data-position]')
      if (positionCell) positionCell.textContent = index + 1
    })
  }
}
